// extracted by mini-css-extract-plugin
module.exports = {"header":"termsConditions_header__ofwYh","headerSubtitle":"termsConditions_headerSubtitle__pgAww","termsConditionsPage":"termsConditions_termsConditionsPage__3T20F"};